import { Theme } from "@mui/material/styles";

import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

const companySummaryStyles = makeStyles((theme: Theme) =>
    createStyles({
        summaryContainer: {
            minWidth: 0,
            display: "flex",
            alignItems: "center",
        },
        companyNameContainer: {
            minWidth: 0,
            lineHeight: "initial",
        },
        summaryHeaderAvatar: {
            backgroundColor: theme.palette.common.white,
            color: theme.palette.others.darkestColor,
            fontSize: 37,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: theme.spacing(2),
            padding: theme.spacing(0, 1),
            width: 63,
            height: 60,
            boxShadow: "0px 4px 6px 0 rgba(0, 0, 0, 0.1)",
            "& .MuiAvatar-img": {
                maxWidth: "100%",
                objectFit: "contain",
            },
        },
        summaryHeaderTruncatedName: {
            fontSize: "clamp(1.7rem, 1.7vw, 2.4rem)",
            fontWeight: 600,
        },
        summaryHeaderFullName: {
            fontSize: "2.4rem",
            fontWeight: 600,
        },
        summaryHeaderName: {
            fontSize: 30,
            fontWeight: 600,
        },
        summaryItemContainer: {
            display: "flex",
            alignItems: "baseline",
            padding: 0,
            margin: theme.spacing(1, 2, 2),
        },
        summaryItem: {
            marginRight: theme.spacing(4),
            fontSize: 15,
            color: theme.palette.secondary.main,
            fontWeight: 400,
            "& .MuiSvgIcon-root": {
                fontSize: 20,
            },
        },
        summaryItemIcon: {
            color: theme.palette.neutrals.dark,
            marginRight: theme.spacing(1),
        },
        summaryItemLabel: {
            letterSpacing: "1.56px",
            textUnderlineOffset: "4px",
            textDecoration: "underline",
            textDecorationColor: "rgba(16, 47, 82, 0.4)",
        },
        summaryItemLink: {
            fontSize: 15,
            color: theme.palette.secondary.main,
            textUnderlineOffset: "5px",
        },
        summaryIconLink: {
            color: theme.palette.secondary.main,
            marginRight: theme.spacing(1),
        },

        summaryItemValue: {
            fontSize: 14,
            color: theme.palette.text.primary,
        },
        summaryLink: {
            color: theme.palette.primary.main,
        },
        summaryHeaderCompanyLink: {
            display: "flex",
            alignItems: "center",
            textDecoration: "underline",
            textUnderlineOffset: "4px",
            color: theme.palette.primary.main,
            fontWeight: 400,
            fontSize: 12,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            "& .MuiTooltip-popper": {
                backgroundColor: theme.palette.others.darkerColor,
            },
        },
        linkIcon: {
            width: 14,
            height: 14,
            marginLeft: `${theme.spacing(1)} !important`,
        },
        projectionHeaderHiddenPanel: {
            backgroundColor: theme.palette.background.blue,
            paddingBottom: 0,
            position: "absolute",
            zIndex: -1,
            top: "100%",
            left: 0,
            width: "100%",
            boxShadow: "0 2px 10px #646464",
        },
        projectionHeaderCompanyContainer: {
            padding: theme.spacing(2, 2),
            zIndex: 2,
            [theme.breakpoints.down("lg")]: {
                padding: theme.spacing(1.8, 3),
            },
        },
    })
);

export default companySummaryStyles;
